import styled from 'styled-components';

export const SelectedControls = styled.section`
	grid-row: 2;
	display: grid;
	align-items: center;
	justify-content: start;
`;